// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"26089566","2860":"5583c8ec","3115":"a437714b","4071":"96231c42","4242":"40a603a0","5340":"c420036b","5431":"40d945be","8110":"a437714b","9307":"568aa915"}[chunkId] + ".chunk.css";
};